import { PaymentWorkflowType } from '../../../container/forms/types/api/graph.types';
import { SectionKey } from '../../../../types';

/** API value mappings for specific field names (snake_case). */
export const VALUE_MAP: Record<string, Record<string, string>> = {
  interest: { yes: 'yes', no: 'no' },
  payments_count: {
    '5': '1-5PaymentRequestAmount',
    '10': '5+PaymentRequestAmount',
  },
  resp_approve: { yes: 'yes', no: 'no' },
  resp_hold_payment: { yes: 'yes', no: 'no' },
  first_approver: { yes: 'yes', no: 'no' },
};

/** Maps workflow type and API section key to internal SectionKey. */
export const WORKFLOW_SECTION_MAP: Record<
  PaymentWorkflowType,
  Record<string, SectionKey>
> = {
  [PaymentWorkflowType.Undefined]: {
    payment_details: 'payment_details',
    resp_lawyer: 'resp_lawyer',
    first_partner: 'first_partner',
    second_partner: 'second_partner',
    payment_hold_review: 'payment_hold_review',
    'Payment Hold Review': 'payment_hold_review',
    payment_confirmation: 'payment_confirmation',
    document_saving: 'document_saving',
    Rejected: 'rejected_form',
  },
  [PaymentWorkflowType.DubaiPaymentApproval]: {
    payment_details: 'payment_details',
    resp_lawyer: 'resp_lawyer',
    first_partner: 'first_partner',
    second_partner: 'second_partner',
    payment_hold_review: 'payment_hold_review',
    'Payment Hold Review': 'payment_hold_review',
    payment_confirmation: 'payment_confirmation',
    document_saving: 'document_saving',
    Rejected: 'rejected_form',
  },
  [PaymentWorkflowType.DubaiTransferRequisition]: {
    dubai_transfer_requisition_payment_details:
      'dubai_transfer_requisition_payment_details',
    dubai_transfer_requisition_first_partner:
      'dubai_transfer_requisition_first_partner',
    dubai_transfer_requisition_second_partner:
      'dubai_transfer_requisition_second_partner',
    dubai_transfer_requisition_payment_confirmation:
      'dubai_transfer_requisition_payment_confirmation',
    Rejected: 'rejected_form',
  },
  [PaymentWorkflowType.DubaiPaymentFromOfficeAcc]: {
    dubai_payment_from_office_account_payment_details:
      'dubai_payment_from_office_account_payment_details',
    dubai_payment_from_office_account_approver:
      'dubai_payment_from_office_account_approver',
    dubai_payment_from_office_account_payment_confirmation:
      'dubai_payment_from_office_account_payment_confirmation',
    Rejected: 'rejected_form',
  },
  [PaymentWorkflowType.OvertimeApproval]: {
    overtime_approval_request_details: 'overtime_approval_request_details',
    overtime_approval_line_manager: 'overtime_approval_line_manager',
    overtime_approval_finance_confirmation:
      'overtime_approval_finance_confirmation',
    Rejected: 'rejected_form',
  },
    [PaymentWorkflowType.GiftHospitalityDonationUk]: {
    'gift_hospitality_donation_uk_request_details': 'gift_hospitality_donation_uk_request_details',
    'gift_hospitality_donation_uk_approval': 'gift_hospitality_donation_uk_approval',
    Rejected: 'rejected_form',
  },
  [PaymentWorkflowType.GiftHospitalityDonationDubai]: {
    'gift_hospitality_donation_dubai_request_details': 'gift_hospitality_donation_dubai_request_details',
    'gift_hospitality_donation_dubai_approval': 'gift_hospitality_donation_dubai_approval',
    Rejected: 'rejected_form',
  },
  [PaymentWorkflowType.GiftHospitalityDonationDublin]: {
    'gift_hospitality_donation_dublin_request_details': 'gift_hospitality_donation_dublin_request_details',
    'gift_hospitality_donation_dublin_approval': 'gift_hospitality_donation_dublin_approval',
    Rejected: 'rejected_form',
  },
// PLOP_INJECT_WORKFLOW_SECTION_MAP
};
